<template>
  <div class="security_re">
		<div class="security_content">
			<h2 class="title">23项措施 全方位安全保障</h2>
			<div class="content_wrap" >
				<div class="tabs_box">
					<div 
						v-for="(item, index) in tabsList"
						:class="[`tabs_box_item`, `tabs_box_item_${index + 1}`, index + 1 == currIdx ? 'active' : '']"
						@click="chooseTabs(index + 1)" :key="item"
					>
						<div class="tabs_icon"></div>
						{{ item }}
					</div>
				</div>
				<div
					class="content_text"
				 	v-touch:swipe.left="touchLeft"
      		v-touch:swipe.right="touchRight"
				>
					<div v-for="(item, index) in itemList" :class="['item_box',  currIdx == index + 1 ? 'active' : '']" :key="item.title" >
						<p class="detail_title">{{ item.title }}</p>
						<div class="top_wrap">
							<img class="detail_img" :src="item.img" alt="" draggable="false">
							<div class="detail_wrap">
								<p class="detail_item" v-for="ditem in item.detailList" :key="ditem">{{ditem}}</p>
							</div>
						</div>
					</div>
					<div class="btn_wrap">
						<router-link  to="/enterprise" class="dt_btn">立即试用</router-link>
						<a class="dl_btn" href="https://www.todesk.com/mobile/#/news/461">白皮书下载</a>
					</div>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
export default {
  name: "Security",
  data() {
    return {
			currIdx: 1,
			tabsList: ['连接日志', '操作录屏', '文件传输'],
			itemList: [
				{
					title: '永久日志记录',
					img: 'https://todeskcdnspeed.todesk.com/20230908185542604d6d15dfebec.png',
					detailList: [
						'账号、设备、时间、连接方式、连接详情，五个核心要素全记录',
						'智能搜索，快速定位查找目标',
						'详细日志永久保存，即查即看'
					],
				},
				{
					title: '云端加密录屏',
					img: 'https://todeskcdnspeed.todesk.com/202304181743445f99924b174248.png',
					detailList: [
						'内容加密存储，仅限管理员解密查看',
						'操作过程完整留档，快速定位回查',
						'云端同步录制，无需等待压缩上传',
					],
				},
				{
					title: '可控文件传输',
					img: 'https://todeskcdnspeed.todesk.com/202304231642055f9fcdd6a9e70c.png',
					detailList: [
						'管理员统一配置员工文件传输权限',
						'主被控文件精细化传输权限',
						'详细记录传输日志，并永久保存'
					],
				}
			],
    };
  },
  mounted() {
  },
  methods: {
    chooseTabs(index = 1) {
			this.currIdx = index
    },
		touchLeft() {
			if(this.currIdx == this.tabsList.length){
        this.currIdx = 1;
      }else{
        this.currIdx ++
      }
		},
		touchRight() {
			if(this.currIdx == 1){
        this.currIdx = this.tabsList.length;
      }else{
        this.currIdx --
      }
		}
  },
};
</script>

<style scoped lang="less">
.security_re {
	width: 100%;
	height: 767px;
	background-color: rgb(244, 244, 247);
	position: relative;
	overflow: hidden;
	.security_content {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		z-index: 1;
		// overflow: hidden;
		.title {
			padding-top: 40px;
			font-family: PingFang SC;
			font-size: 26px;
			font-weight: 600;
			line-height: 36px;
			letter-spacing: 0px;
			text-align: center;
			text-align: center;
			color: #000000;
		}
		.content_wrap {
			width: 100%;
			height: 664px;
			position: relative;
			margin-top: 25px;
			overflow: hidden;
			.tabs_box {
				user-select: none;
				width: 303px;
				height: 82px;
				margin: 0 auto;
				display: flex;
				justify-content: space-between;
				.tabs_box_item {
					position: relative;
					cursor: pointer;
					width: 107px;
					height: 30px;
					display: flex;
					align-items: center;
					justify-content: center;
					background-color: transparent;
					border-radius: 44px;
					font-family: 'PingFang SC';
					font-weight: 400;
					font-size: 13px;
					line-height: 18px;
					text-align: center;
					color: #747576;
					.tabs_icon {
						width: 16px;
						height: 16px;
						margin-right: 3px;
						background-size: 100% auto;
						background-repeat: no-repeat;
						background-position: 0 50%;
					}
					&_1 {
						.tabs_icon {
							background-image: url('~@/assets/home/icon-link-dark.png');
						}
						&::after {
							content: '';
							position: absolute;
							left: 44%;
							top: 40px;
							width: 105px;
							height: 20px;
							border: 1px dashed transparent;
							border-left-color: #CED0D4;
							border-bottom-color: #CED0D4;
							border-bottom-left-radius: 10px 10px;
						}
					}
					&_2 {
						.tabs_icon {
							background-image: url('~@/assets/home/icon-record-dark.png');
						}
						&::after {
							content: '';
							position: absolute;
							top: 60px;
							width: 1px;
							height: 20px;
							border: 1px dashed transparent;
							border-left-color: #0070F9;
						}
						&::before {
							content: '';
							position: absolute;
							top: 40px;
							width: 1px;
							height: 20px;
							border: 1px dashed transparent;
							border-left-color: #CED0D4;
						}
					}
					&_3 {
						.tabs_icon {
							background-image: url('~@/assets/home/icon-translate-dark.png');
						}
						&::after {
							content: '';
							position: absolute;
							right: 46%;
							top: 40px;
							width: 105px;
							height: 20px;
							border: 1px dashed transparent;
							border-right-color: #CED0D4;;
							border-bottom-color: #CED0D4;
							border-bottom-right-radius: 10px 10px;
						}
					}
					&.active {
						background-color: #161616;
						color: #FFFFFF;
						box-shadow: 0px 2.4px 3.2px rgba(0, 0, 0, 0.1);
						&.tabs_box_item_1 {
							.tabs_icon {
								background-image: url('~@/assets/home/icon-link-light.png');
							}
							&::after {
								border-left-color: #0070F9;
								border-bottom-color: #0070F9;
							}
						}
						&.tabs_box_item_2 {
							.tabs_icon {
								background-image: url('~@/assets/home/icon-record-light.png');
							}
							&::before {
								border-left-color: #0070F9;
							}
						}
						&.tabs_box_item_3 {
							.tabs_icon {
								background-image: url('~@/assets/home/icon-translate-light.png');
							}
							&::after {
								border-right-color: #0070F9;
								border-bottom-color: #0070F9;
							}
						}
					}
				}
			}
			.content_text {
				width: 100%;
				height: 584px;
				position: relative;
				display: flex;
				touch-action: pan-y;
				.item_box {
					flex-shrink: 0;
					position: absolute;
					top: 0;
					width: 375px;
					height: 100%;
					z-index: -1;
					opacity: 0;
					&.active {
						opacity: 1;
					}
					.detail_title {
						width: 335px;
						font-family: PingFang SC;
						font-size: 24px;
						font-weight: 600;
						line-height: 34px;
						letter-spacing: 1px;
						text-align: center;
						margin: 0 auto;
					}
					.top_wrap {
						padding-top: 13px;
						.detail_img {
							width: 335px;
							height: auto;
							display: block;
							margin: 0 auto;
						}
						.detail_wrap {
							width: 285px;
							margin: 0 auto;
							margin-top: 20px;
							.detail_item {
								box-sizing: border-box;
								font-family: PingFang SC;
								font-size: 14px;
								font-weight: 400;
								line-height: 20px;
								letter-spacing: 0px;
								text-align: left;
								color: rgba(97, 99, 105, 1);
								padding-left: 14px;
								position: relative;
								margin-top: 8px;

								&::before {
									content: '·';
									position: absolute;
									top: 0;
									left: 0;
								}
								&:last-of-type {
									margin-bottom: 0;
								}
							}
						}
					}
				}
				.btn_wrap {
					position: absolute;
					bottom: 38.47px;
					width: 375px;
					display: flex;
					justify-content: center;
					.dt_btn {
						width: 159px;
						height: 40px;
						box-sizing: border-box;
						border-radius: 6px;
						background-color: #0070f9;
						display: flex;
						align-items: center;
						justify-content: center;
						font-family: 'PingFang SC';
						font-weight: 400;
						font-size: 16px;
						line-height: 22px;
						color: #FFFFFF;
						transition: background-color 0.3s;
						margin-right: 16px;
						&:active {
							background-color: rgba(0, 112, 255, 0.8);
						}
					}
					.dl_btn {
						width: 159px;
						height: 40px;
						box-sizing: border-box;
						border-radius: 6px;
						background-color: #FFFFFF;
						border: 1px solid #E9EBEF;
						display: flex;
						align-items: center;
						justify-content: center;
						font-family: 'PingFang SC';
						font-weight: 400;
						font-size: 16px;
						line-height: 22px;
						color: #0070F9;
						transition: background-color border-color 0.3s;
						&:active {
							border: 1px solid rgb(217, 218, 223);
							background-color: rgba(255, 255, 255, 0.9);
							color: #1c87fd;
						}
					}
				}
			}
		}
		.content_img {
			width: 534px;
			height: 522px;
			position: relative;
			flex-shrink: 0;
			margin-right: auto;
			img {
				position: absolute;
				top: 0;
				width: 100%;
				height: 100%;
				display: block;
				z-index: 0;
				opacity: 0;
				&.active {
					z-index: 1;
					opacity: 1;
				}
			}
		}
	}
}
</style>